<template>
  <div class="embed-container">
    <iframe
      id="help-iframe"
      src="https://socci.esa.int/www/gssc_iapplications/Quick_Start_Guide.html"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('mounted RUN')
    this.$emit('finishLoading')
  },
}
</script>

<style lang="scss" scoped>
.embed-container {
  margin: 0 -15px;
  #help-iframe {
    width: 100%;
    height: calc(100vh - 64px - 64px - 80px);
    border: none;
    overflow: hidden;
  }
}
</style>
